import { ReactNode } from "react";
import { useQuestionizerStore } from "../types/state.ts";
import { Button } from "./button.tsx";

export function Group(props: {id: string, group_id: number, index: number, active: boolean, children: ReactNode | Array<ReactNode>}){
  // const deactivateGroup = useQuestionizerStore((state) => state.deactivateGroup);
  
  return <div 
          aria-labelledby={'title-'+props.id}
          aria-describedby={'description-'+props.id}
          inert={!props.active} 
          aria-expanded={props.active}
          className={
            "section--group group group-"+props.group_id + 
            (" section section-" + props.id) + 
            (props.active ? "" : " section--hidden")
          } 
          key={props.id}
        >
          {/* <button 
            type="button"
            aria-label="schließen"
            aria-hidden
            className="modal__close-button"
            onClick={()=>{
              deactivateGroup();
            }}
          ></button> */}
          {props.children}
          
    </div>;
}

{/* {is_group_section && 
} */}